import ConfigConnected from '@clearkit/icons/indicators/ConfigConnected';
import { CKBox, CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

import Logo from '~/components/ConfigurationLogo';
import paths from '~/lib/paths';

export default function AccountConnectorAction({ accountConnector }) {
  if (!accountConnector) {
    return null;
  }

  return (
    <CKBox
      variant={CKBox.Variant.card}
      className="flex flex-row items-center px-4 py-3">
      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-0">
        <ConfigConnected width={24} height={16} />
      </div>
      <div className="px-4 border-r border-gray-100">
        <p className="text-sm font-medium">Active Connection</p>
        <p className="flex flex-row items-center text-sm text-gray-600">
          <Logo
            type={accountConnector.service}
            className="mr-1"
            width={18}
            height={18}
          />
          {accountConnector.remoteMeta?.name}
        </p>
      </div>
      <CKButton
        as={Link}
        className="ml-4"
        to={paths.configuration(accountConnector.service)}
        variant="tertiary"
        variantColor="blue">
        Manage
      </CKButton>
    </CKBox>
  );
}
